module.exports = __webpack_public_path__ + "img/template5.54e9ad46.png";